module.exports = __webpack_public_path__ + "img/olive-profilePix.83831b35.jpg";